import { useAtom } from "@reatom/npm-react";
import { useCallback, useMemo } from "react";
import { type SingleValue } from "react-select";
import { VirtualMultiSelect } from "src/components";

import { sortAtom } from "../../store/atoms";
import { sortOptions } from "./ProductSort.constants";

export const ProductSort = () => {
  const [sort, setSort] = useAtom(sortAtom);

  const value = useMemo(() => {
    return sortOptions.find((option) => option.type === sort?.type)?.id || 1;
  }, [sort?.type]);

  const options = useMemo(
    () =>
      sortOptions.map((option) => ({
        label: option.title,
        value: option.id,
      })),
    [],
  );

  const onChange = useCallback(
    (value: SingleValue<number> | undefined) => {
      if (!value) return;
      const option = sortOptions.find((option) => option.id === value);

      if (!option?.type) return setSort(null);

      setSort({ type: option.type });
    },
    [setSort],
  );

  return (
    <VirtualMultiSelect<number>
      placeholder="Выберите сортировку"
      value={value}
      options={options}
      onChange={onChange}
    />
  );
};
